<template>
  <main class="sa-content">
      <div class="sa-card-large">
        <add-diagnosis-det ref="diagnosis" :primary="primaryDiag" :additional="additionalDiag"  :secondary="secondaryDiag" @assessment="assessmentPop()" />
      </div>
      <div class="sa-dialog sa-assegements" v-if="primaryFlag">
        <div class="sa-dialog-body sa-device ">
              <i class="icon-arrow-left sa-f-size22" @click="goback()"></i>
             <!-- <i class="icon-close sa-close sa-btn sa-close-line" @click="goback()"></i> -->
            <div class="sa-row sa-mt20 sa-d-f-a-center">
              <div class="sa-col-xs12 sa-col-sm5 sa-col-md5 sa-col-lg4">
                <div class="sa-form-group">
                  <input type="text" class="sa-form-control sa-dark-search " id="searchDiagonosis" name="Search Diagonosis"  @input="changeType" v-model="icd_search" placeholder="Search Diagonosis" /><i class="icon-search sa-search"></i>
                </div>
              </div>
              <div class="sa-col-xs12 sa-col-sm7 sa-col-md7 sa-col-lg8 sa-text-right">
                  <span @click="primaryClear" class="sa-clear sa-cursor">Clear all</span>
              </div>
            </div>
            <ul class="sa-infinite sa-infinite-height">
              <li v-for="(item, index) in list" :key="index">
                <input :value="item.icd10_code" v-model="primaryDiag" type="checkbox" :id="index" :name="index">
                <label :for="index">{{item.en}}</label>
              </li>
              <infinite-loading :identifier="infiniteId" @infinite="assessmentDet" spinner="waveDots">
                <span slot="no-results">No results</span>
                <span slot="no-more"></span>
              </infinite-loading>
            </ul>
              
            <div class="sa-ftr-btn">
              <button @click="saveDiagnosisDet"  class=" sa-btn-large sa-btn-primary sa-btn-block-xs">Continue</button>
          </div>
        </div>
      </div>
      <div class="sa-dialog sa-assegements" v-if="secondaryFlag">
        <div class="sa-dialog-body sa-device ">
            <i class="icon-arrow-left sa-f-size22" @click="secondaryFlag=false"></i>
             <!-- <i class="icon-close sa-close sa-btn sa-close-line" @click="secondaryFlag=false"></i> -->
            <div class="sa-row sa-mt20 sa-d-f-a-center">
              <div class="sa-col-xs12 sa-col-sm5 sa-col-md5 sa-col-lg4">
                <div class="sa-form-group">
                  <input type="text" class="sa-form-control sa-dark-search " @input="changeType" id="icdSearch" name="icdsearch" v-model="icd_search" placeholder="Search Diagonosis" /><i class="icon-search sa-search"></i>
                </div>
              </div>
              <div class="sa-col-xs12 sa-col-sm7 sa-col-md7 sa-col-lg8 sa-text-right">
                  <span @click="secondaryClear" class="sa-clear sa-cursor">Clear all</span>
              </div>
            </div>
            <ul class="sa-infinite sa-infinite-height">
              <li v-for="(item, index) in list" :key="index">
                <input :value="item.icd10_code" v-model="secondaryDiag" type="checkbox" :id="index" :name="index">
                <label :for="index">{{item.en}}</label>
              </li>
              <infinite-loading :identifier="infiniteId" @infinite="assessmentDet" spinner="waveDots">
                <span slot="no-results">No results</span>
                <span slot="no-more"></span>
              </infinite-loading>
            </ul>
              
            <div class="sa-ftr-btn">
              <button @click="saveDiagnosisDet"  class=" sa-btn-large sa-btn-primary sa-btn-block-xs">Continue</button>
          </div>
        </div>
      </div>
      <div class="sa-dialog sa-assegements" v-if="additionalFlag">
        <div class="sa-dialog-body sa-device ">
            <i class="icon-arrow-left sa-f-size22" @click="additionalFlag=false"></i>
            <!-- <i class="icon-close sa-close sa-btn sa-close-line" @click="additionalFlag=false"></i> -->
            <div class="sa-row sa-mt20 sa-d-f-a-center">
              <div class="sa-col-xs12 sa-col-sm5 sa-col-md5 sa-col-lg4">
                <div class="sa-form-group">
                  <input type="text" class="sa-form-control sa-dark-search " @input="changeType" v-model="icd_search" placeholder="Search Diagonosis" id="search" name="search" /><i class="icon-search sa-search"></i>
                </div>
              </div>
              <div class="sa-col-xs12 sa-col-sm7 sa-col-md7 sa-col-lg8 sa-text-right">
                  <span @click="additionalClear" class="sa-clear sa-cursor">Clear all</span>
              </div>
            </div>
            <ul class="sa-infinite sa-infinite-height">
              <li v-for="(item, index) in list" :key="index">
                <input :value="item.icd10_code" v-model="additionalDiag" type="checkbox" :id="index" :name="index">
                 <label :for="index">{{item.en}}</label>
              </li>
              <infinite-loading :identifier="infiniteId" @infinite="assessmentDet" spinner="waveDots">
                <span slot="no-results">No results</span>
                <span slot="no-more"></span>
              </infinite-loading>
            </ul>
              
            <div class="sa-ftr-btn">
              <button @click="saveDiagnosisDet" class=" sa-btn-large sa-btn-primary sa-btn-block-xs">Continue</button>
          </div>
        </div>
      </div>
      <div class="sa-dialog sa-sorrypopup" v-if="sorryFlag">
        <div class="sa-dialog-body sa-small "><i class="icon-cancel sa-close sa-btn sa-close sa-close-line" @click="sorryFlag=false"></i>
            <i class="sa-sprite sa-time"></i>
            <h5 class="sa-mt20">We are sorry !</h5>
            <p>Your selected slot was not available right now. Please select one other slot.</p><button class="sa-btn sa-btn-primary sa-btn-large sa-btn-block-xs">Select Slot</button></div>
      </div>
  </main>
</template>
<script>

import { pro_url, oh_url } from "../../../../config/endpoints";
import AddDiagnosisDetVue from '../../../components/appointments/diagnosis/AddDiagnosisDet.vue';
import InfiniteLoading from "vue-infinite-loading";
import axios from 'axios';
import _ from 'lodash';
const api = '//hn.algolia.com/api/v1/search_by_date?tags=story';
export default {
   mounted() {
    // this.assessmentDet();
  },
  components: {
    "add-diagnosis-det": AddDiagnosisDetVue,
    "infinite-loading": InfiniteLoading,
  },
  data() {
    return {
      details: null,
      userInfo: {},
      app_stat: "3",
      primaryDiag:[],
      secondaryDiag: [],
      additionalDiag: [],
      clinicInfoReq:"",
      additionalFlag: false,
      secondaryFlag: false,
      primaryFlag:false,
      sorryFlag:false,
      page: 1,
      list: [],
      infiniteId: +new Date(),
      icd_search: "",
      patDetails:{}
    };
  },
  created() {
    let _self = this;
    let aid = this.$route.params.appid;
    _self.getData(aid);
    _self.userInfo = JSON.parse(_self.$localStorage.get("userdata")) || {};
  },
  methods: {
    infiniteHandler($state) {
      axios.get(api, {
        params: {
          page: this.page,
        },
      }).then(({ data }) => {
        if (data.hits.length) {
          this.page += 1;
          this.list.push(...data.hits);
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    assessmentPop: function() {
      this.additionalFlag = true
      this.primaryFlag = true
      this.secondaryFlag = true
    },
    getData(aid) {
      console.log(aid,'ddddddddddddddddddd');
      let _self = this;
      _self.loading = true;
      let wobj = {};
      _self.$store
        .dispatch("httpGet", {
          uri: `${pro_url}/apt/${aid}`,
          query: wobj
        })
        .then(response => {
          if (response && response.status === 1000) {
            _self.details = response.data;
            let data = {
              followUp : _self.details.followUp,
              stid : _self.details.stid,
              date : _self.details.date,
              time : _self.details.time,
              strt_tym: _self.details.strt_tym
            }
            _self.patDetails.apnt_id = response.data.apnt_id
            _self.patDetails.sanar_uid = response.data.sanar_uid
            _self.patDetails.pid = response.data.pid
            _self.patDetails.status = response.data.status
            _self.patDetails.stid = response.data.stid
            _self.patDetails.apnt_date = response.data.date
             _self.$localStorage.set('patDetails', JSON.stringify(_self.patDetails))
             _self.$localStorage.set('apntDet', JSON.stringify(data))
             _self.$localStorage.remove('followUp')
            _self.app_stat = _self.details.status;
            if (_self.details.status == "7" || _self.details.status == "9") {
              _self.app_stat = "3";
            }
            _self.loading = false;
          } else {
            console.log('error');
          }
        })
        .catch(e => {
        });
    },
     assessmentDet($state){
        let _self = this
      _self.loading = true
      _self.$store.dispatch('httpPost', {
        uri:`${oh_url}/general/ICD10codesListDesk`,
        body: {
          limit: 10,
	        page: this.page,
          en: this.icd_search
          }
      }).then(response => {
        _self.loading = false
        if (response && response.status === 1000 && response.data && response.data.data && response.data.data.length) {
          _self.page += 1
          _self.list.push(...response.data.data);
          _self.list =_.uniqBy(_self.list, function(o){ return o.icd10_code;});
          $state.loaded()
        } else {
          $state.complete()
        }
      })
    },
     changeType() {
      this.page = 1;
      this.list = [];
      this.infiniteId += 1;
    },
    primaryClear(){
      this.primaryDiag=[];
    },
    secondaryClear(){
      this.secondaryDiag= [];
    },
    additionalClear(){
       this.additionalDiag= [];
    },
      saveDiagnosisDet() {
        let _self = this;
      _self.loader = true;
       let preg_status = _self.$refs['diagnosis'].diagnosis.general_details ? (_self.$refs['diagnosis'].diagnosis.general_details.pregnency_status == 'Yes' ? true : false) : false
      let plan = _self.$refs['diagnosis'].diagnosis.diagnosis_details ? 
      (_self.$refs['diagnosis'].diagnosis.diagnosis_details.plan == '' ? undefined : _self.$refs['diagnosis'].diagnosis.diagnosis_details.plan)
      :_self.$refs['diagnosis'].diagnosis.diagnosis_details.plan;
      // console.log(_self.list);
      let data = {}
      _.map(_self.primaryDiag,e=>{
        let ref = _self.list.find(f => e == f.icd10_code)
        data[e] = ref.en
        return e
      })
      _.map(_self.secondaryDiag,e=>{
        let ref = _self.list.find(f => e == f.icd10_code)
        data[e] = ref.en
        return e
      })
      _.map(_self.secondaryDiag,e=>{
        let ref = _self.list.find(f => e == f.icd10_code)
        data[e] = ref.en
        return e
      })
       _self.$localStorage.set('assesment', JSON.stringify(data))
      let assessment = {
        primary : _self.primaryDiag,
        secondary : _self.secondaryDiag,
        additional : _self.additionalDiag
      }
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/apt/update`,
          body: {
            apnt_id: _self.$route.params.appid,
            summary: assessment,
            preg_status: preg_status,
            subjective: _self.$refs['diagnosis'].diagnosis.diagnosis_details.subjective,
            treatment_plan : plan,
            objective: _self.$refs['diagnosis'].diagnosis.diagnosis_details.objective,
            marital_status: _self.$refs['diagnosis'].diagnosis.general_details.marital_status
          },
        })
        .then((response) => {
          _self.loader = false;
          if (response && response.status === 1000) {
           // _self.$parent.assessmentFlag=false
            _self.additionalFlag=false
            _self.primaryFlag = false
            _self.secondaryFlag = false
            _self.$refs.diagnosis.diagnosisDetails()
            _self.icd_search = ''
             _self.$refs.diagnosis.height("a");
          }else {
            _self.additionalFlag=false
            _self.primaryFlag = false
            _self.secondaryFlag = false
             _self.$store.dispatch("SET_ALERTMESSAGE", {
            msg: response.err,
            class: "sa-a-danger"
          });
            _self.$refs.diagnosis.diagnosisDetails()
          }
          
        })
    },
     diagnosisDetails(){
      let _self = this;
      _self.loader = true;
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/diagnosis/diagnosisDetails`,
          body: {
            apnt_id: _self.$route.params.appid,
          },
        })
        .then((response) => {
          _self.loader = false;
          if (response && response.status === 1000) {
            _self.diagnosis = response.data;
          }
          
        })
    },
    goback(){
      this.primaryFlag=false
      this.icd_search = ''
    }
  }
};
</script>
